import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  standalone: false
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
  @Input() loading$: Observable<boolean>;
  @Input() visible: boolean;

  @Input() header: string;
  @Input() body: string;
  @Input() closeAlt?: string;
  @Input() cancelLabel?: string;
  @Input() confirmLabel?: string;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();

  private readonly destroyed$: Subject<boolean> = new Subject<boolean>();

  ngOnInit() {
    this.loading$.pipe(takeUntil(this.destroyed$)).subscribe((loading) => {
      if (!loading) {
        this.onClose();
      }
    });
  }

  onConfirm() {
    this.confirm.emit();
  }

  onClose() {
    this.visibleChange.emit(false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
